import React from 'react';

function HomePage(props) {
  return (
    <div className='home-page'>
      <h1>What will you improve today?</h1>
    </div>
  );
}

export default HomePage;